export const userIdType = [
  {
    label: '身份证',
    value: 1
  }, {
    label: '护照',
    value: 3
  }, {
    label: '港澳通行证',
    value: 2
  }, {
    label: '其他',
    value: 4
  }
]
export const sexType = [
  {
    label: '男',
    value: 1
  }, {
    label: '女',
    value: 0
  }
]

export const gradeType = [
  '一年级',
  '二年级',
  '三年级',
  '四年级',
  '五年级',
  '六年级',
  '七年级',
  '八年级',
  '九年级',
  '高一',
  '高二',
  '高三'
]
